import React, { useState, useRef, Fragment } from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const MarkComplete = ({ onComplete }) => {
  const actionButton = useRef(null);

  const [showModal, setShowModal] = useState(false);

  const ariaLabelledBy =
    'mark-complete-warning-description mark-complete-controls';

  const onActionClick = (e) => {
    e.stopPropagation();
    setShowModal(!showModal);
    if (actionButton.current) {
      actionButton.current.focus();
    }
  };

  const onCancelClick = () => {
    setShowModal(false);

    if (actionButton.current) {
      actionButton.current.focus();
    }
  };

  const onSubmit = () => {
    setShowModal(false);
    onComplete();
  };

  return (
    <Fragment>
      {showModal && (
        <ConfirmDialog
          size="small"
          title="Mark Complete"
          onClose={onCancelClick}
          onSuccess={onSubmit}
          aria={{
            live: 'polite',
            labelledby: 'title',
            describedBy: 'mark-complete-warning',
          }}
          content={{
            btnSecondary: 'No',
            btnPrimary: 'Yes',
          }}
        >
          <div id="mark-complete-warning" aria-labelledby={ariaLabelledBy}>
            <p id="mark-complete-warning-description">
              Are you sure you want to complete this assignment? Any students
              who have not submitted this quiz will not be able to do so once
              you mark it complete, though you will be able to reassign this
              quiz to your entire class.
              <br />
              <br />
              <strong>Note:</strong>&nbsp; to reopen this assignment, find it in
              the &#39;Completed&#39; page under &#39;Assignments&#39; and click
              &#39;Re-open&#39;.
            </p>
          </div>
        </ConfirmDialog>
      )}

      <AccessibilityWrapper>
        <SingleAction
          onClick={onActionClick}
          tabIndex={0}
          aria-label="Mark Complete"
          ref={actionButton}
          iconName="mark_complete"
        >
          <span className="item-text">Mark Complete</span>
        </SingleAction>
      </AccessibilityWrapper>
    </Fragment>
  );
};

export default MarkComplete;
